import { AxiosError } from 'axios';
import { Auth, IAuthResponse } from '../Auth';
import { AuthProvider } from './AuthProvider';

export type SamlAuthParameter = {
  SAMLResponse: string;
};
export class SamlLogin extends AuthProvider<SamlAuthParameter> {
  constructor(auth: Auth) {
    super(auth);
  }

  public login(credentials: SamlAuthParameter): Promise<boolean> {
    this.validateConfig();
    // treat everything that starts with < as XML and do base64 encoding (can't possibly already be base64)
    if (credentials.SAMLResponse.startsWith('<')) {
      credentials.SAMLResponse = btoa(credentials.SAMLResponse);
    }
    credentials.SAMLResponse = encodeURIComponent(credentials.SAMLResponse);

    const startTime = Date.now();
    return this.auth
      .request({
        url: `${this.auth.Config.auth.urlSession}/samllogin?fetchToken=true`,
        method: 'post',
        headers: {
          accept: '*/*',
          // specified by the SAML Protocol
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        timeout: this.auth.RequestTimeout,
        data: `SAMLResponse=${credentials.SAMLResponse}`,
      })
      .then((response: IAuthResponse) =>
        this.createSession(response, null, Date.now() - startTime, true)
      )
      .then(this.getTokenFromCredentials.bind(this))
      .then(() => true)
      .catch((error: AxiosError) => {
        this.logout().then(() => true);
        return Promise.reject(error);
      });
  }
}
